<template>
    <div class="booking-list">
        <div class="header text-center h-48">
            <span>オンライン服薬指導の予定表</span>
        </div>

        <div class="p-25">
          <el-select @change="(e) => handleSelectPharmacy(e)" class="pharmacist-select" v-model="selectedPharmacyId" placeholder="薬剤師">
            <el-option
                v-for="item in pharmacies"
                :key="item.id"
                :label="item.pmc_dsp_name"
                :value="item.id">
            </el-option>
          </el-select>
            <div class="button-control mb-15">
                <div @click="prevWeek()" class="pre-button">
                    <span class="cursor-pointer">
                      <img src="../../assets/icon/arrow-left.png" alt="">
                      <span>先週を確認</span>
                    </span>
                </div>
                <div @click="currentWeek()" class="current-week text-center">
                    <span class="cursor-pointer">今週を確認</span>
                </div>
                <div @click="nextWeek()" class="next-button text-right">
                    <span class="cursor-pointer">
                      <span>次週を確認</span>
                      <img src="../../assets/icon/arrow-right.png" alt="">
                    </span>
                </div>
            </div>
            <div class="position-relative" v-loading="loadingListBookingTable">
                <div class="table-scroll" id="table-scroll">
                        <table class="booking-table text-center" id="booking-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th v-if="daysDisplay[0]">{{`${daysDisplay[0].month}月${daysDisplay[0].day}日`}}（月）</th>
                                <th v-if="daysDisplay[1]">{{`${daysDisplay[1].month}月${daysDisplay[1].day}日`}}（火）</th>
                                <th v-if="daysDisplay[2]">{{`${daysDisplay[2].month}月${daysDisplay[2].day}日`}}（水）</th>
                                <th v-if="daysDisplay[3]">{{`${daysDisplay[3].month}月${daysDisplay[3].day}日`}}（木）</th>
                                <th v-if="daysDisplay[4]">{{`${daysDisplay[4].month}月${daysDisplay[4].day}日`}}（金）</th>
                                <th v-if="daysDisplay[5]">{{`${daysDisplay[5].month}月${daysDisplay[5].day}日`}}（土）</th>
                                <th v-if="daysDisplay[6]">{{`${daysDisplay[6].month}月${daysDisplay[6].day}日`}}（日）</th>
                            </tr>
                            </thead>
                            <tbody id="tbody-booking" style="">
                            <tr v-for="(item, index) in listTime" :key="index" :id="item.time">
                                <td style="position: relative;" >{{item.time}}</td>
                                <td v-for="(item2, index2) in item.days_display" :key="index2">
                                  <span class="circle-marker inline" :class="{'booked': item2.is_booked, 'participants-list': item2.meeting &&  item2.meeting.participants.length > 0}">
                                    <span class="first-participant">
                                      {{item2.meeting &&  item2.meeting.participants.length > 0 ? item2.meeting.participants[0].name : ''}}
                                    </span> <br>
                                    <span class="rest-of-participants" v-if="item2.meeting && item2.meeting.participants.length > 1">
                                      <el-tooltip class="item" effect="dark" placement="left">
                                        <div slot="content">
                                          <div class="more-users-tooltip" v-html="item2.meeting.participants.map(n => n.name).splice(1, item2.meeting.participants.length).join('<br>')"></div>
                                        </div>
                                        <el-button class="show-more-users">他{{item2.meeting.participants.length - 1}}名</el-button>
                                      </el-tooltip>
                                    </span>
                                  </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import CalendarApi from '@/api/calendar'
import MasterDataApi from'@/api/master'
import {zeroPadNumber, apiErrorDialog} from '@/helpers'

export default {
  data () {
    return {
      listTime: [],
      calendars: [],
      pharmacies: this.$auth.user().pharmacies,
      loadingListBookingTable: false,
      selectedPharmacyId: this.$auth.user().pharmacies[0].id,
      firstDayOfWeek: moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD'),
      endDayOfWeek: moment(this.now).endOf('week').add(1, 'days').format('YYYY-MM-DD'),
      daysDisplay: [],
      now: moment(new Date()).format('YYYY-MM-DD'),
      startTimeBooking: moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00'),
      endTimeBooking: moment(this.now).startOf('week').add(7, 'days').format('YYYY-MM-DD 23:59:59'),
      distantTime: 30
    }
  },
  methods: {
    async handleChangeWeek () {
      this.daysDisplay = []
      this.firstDayOfWeek = moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00')
      this.endDayOfWeek = moment(this.now).endOf('week').add(1, 'days').format('YYYY-MM-DD 23:59:59')
      await this.fetchDateTime()
    },
    nextWeek () {
      this.now = moment(this.now).add(7, 'days').format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.startTimeBooking).add(7, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.endTimeBooking).add(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      this.handleChangeWeek()
    },
    prevWeek () {
      this.loadingListBookingTable = true
      this.now = moment(this.now).subtract(7, 'days').format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.startTimeBooking).subtract(7, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.endTimeBooking).subtract(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      this.handleChangeWeek()
    },
    async currentWeek () {
      this.loadingListBookingTable = true
      this.now = moment(new Date()).format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.now).startOf('week').add(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      await this.handleChangeWeek()
    },
    handleSelectPharmacy (pharmacyId) {
      this.selectedPharmacyId = pharmacyId
      this.currentWeek()
    },
    async fetchDateTime () {
      this.loadingListBookingTable = true
      this.daysDisplay = []
      for (let i = 0; i < 7; i++) {
        this.daysDisplay.push(
          {
            day: moment(this.firstDayOfWeek).date(),
            month: moment(this.firstDayOfWeek).month() + 1,
            year: moment(this.firstDayOfWeek).year()
          }
        )
        this.firstDayOfWeek = moment(this.firstDayOfWeek).add(1, 'days').format('YYYY-MM-DD')
      }
      await this.fetchListBooking()
      setTimeout(() => { this.loadingListBookingTable = false }, 500)
    },
    scrollTableToLeft () {
      const bookingTable = document.getElementById('booking-table')
      bookingTable.scrollLeft = 0
    },
    async fetchListBooking () {
      const calendarRes = await CalendarApi.getByPharmacyId(
        {
          start: this.startTimeBooking,
          end: this.endTimeBooking
        }, this.$auth.user().pharmacies[0].id
      )
      .catch((error) => {
        apiErrorDialog(this, error)
      })
      this.calendars = calendarRes.data.data
      let listCalendarsRes = []
      this.calendars.forEach(calendar => {
        const tbYear = moment(calendar.start).year()
        const tbMonth = zeroPadNumber(moment(calendar.start).month() + 1)
        const tbDay = zeroPadNumber(moment(calendar.start).date())
        const tbStartHour = zeroPadNumber(moment(calendar.start).hours())
        const tbStartMin = zeroPadNumber(moment(calendar.start).minutes())
        const tbEndHour = zeroPadNumber(moment(calendar.end).hours())
        const tbEndMin = zeroPadNumber(moment(calendar.end).minutes())
        let timeBooked = `${tbYear}-${tbMonth}-${tbDay} ${tbStartHour}:${tbStartMin} - ${tbEndHour}:${tbEndMin}`
        listCalendarsRes.push({
          time: timeBooked,
          id: calendar.id,
          used_by_other_user: calendar.used_by_other_user,
          meeting: calendar.meeting
        })
        calendar.time = timeBooked
      })
      this.handleData()
    },
    getStartTime (time) {
      return time.split('-')[0].trim('')
    },
    getEndTime (time) {
      return time.split('-')[1].trim('')
    },
    fetchConstListTime (start = '00:00', end = '23:30', step = 30) {
      let listTime = []
      let startTime = moment().format(`YYYY-MM-DD ${start}`)
      let endtime = moment().format(`YYYY-MM-DD ${end}`)
      while (moment(startTime).isBefore(endtime)) {
        listTime.push({time: `${moment(startTime).format('HH:mm')} - ${moment(startTime).add(step, 'minutes').format('HH:mm')}`})
        startTime = moment(startTime).add(step, 'minutes')
      }
      this.listTime = listTime
    },
    async handleData () {
      for (let i = 0; i < this.listTime.length; i++) {
        Object.assign(this.listTime[i], {
          days_display: JSON.parse(JSON.stringify(this.daysDisplay))
        })
        for (let j = 0; j < 7; j++) {
          let objTime = this.listTime[i].days_display[j]
          Object.assign(this.listTime[i].days_display[j], {
            time: `${objTime.year}-${zeroPadNumber(objTime.month)}-${zeroPadNumber(objTime.day)} ${this.listTime[i].time}`,
            start_at: `${objTime.year}-${zeroPadNumber(objTime.month)}-${zeroPadNumber(objTime.day)} ${this.getStartTime(this.listTime[i].time)}:00`,
            end_at: `${objTime.year}-${zeroPadNumber(objTime.month)}-${zeroPadNumber(objTime.day)} ${this.getEndTime(this.listTime[i].time)}:00`
          })
        }
      }
      // comparation and get status of cell
      for (let i = 0; i < this.listTime.length; i++) {
        const listTimeItem = this.listTime[i]
        for (let j = 0; j < 7; j++) {
          const daysDisplayItem = listTimeItem.days_display[j]
          let isExpired = null
          let startAt = daysDisplayItem.start_at
          if (moment().isAfter(moment(startAt))) isExpired = true
          Object.assign(this.listTime[i].days_display[j], {
            is_expired: isExpired
          })
          for (let m = 0; m < this.calendars.length; m++) {
            const calendarResItem = this.calendars[m]
            if (daysDisplayItem.time === calendarResItem.time) {
              Object.assign(this.listTime[i].days_display[j], {
                is_booked: true,
                discontinuation: calendarResItem.discontinuation,
                other_booked: calendarResItem.used_by_other_user,
                id: calendarResItem.id,
                meeting: calendarResItem.meeting
              })
            }
          }
        }
      }
      const res = await MasterDataApi.get()
      .catch((error) => {
        apiErrorDialog(this, error)
      })
      const masterData = res.data.data
      const elm = document.getElementById(`${masterData.fixed_time_scrool}`)
      // location.href = `#${masterData.fixed_time_scrool}`
      // const tableScroll = document.getElementById('table-scroll')
      // tableScroll.scrollTop = tableScroll.scrollTop - elm.offsetHeight + 5
      const tableScroll = document.getElementById('table-scroll')
      tableScroll.scrollTop = elm.offsetTop - 38
    }
  },
  mounted () {
    this.fetchConstListTime()
    this.fetchDateTime()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Calendar/List.vue